import { useEffect, useState } from "react";
import { api } from "@/lib/api";

export const STATUS_META = {
  draft: { label: "Draft", tone: "bg-zinc-100 text-zinc-700 border-zinc-300" },
  in_review: { label: "In review", tone: "bg-amber-50 text-amber-800 border-amber-300" },
  approved: { label: "Approved", tone: "bg-emerald-50 text-emerald-800 border-emerald-300" },
  superseded: { label: "Superseded", tone: "bg-zinc-50 text-zinc-500 border-zinc-200" },
  withdrawn: { label: "Withdrawn", tone: "bg-zinc-50 text-zinc-400 border-zinc-200" },
  archived: { label: "Archived", tone: "bg-zinc-200 text-zinc-600 border-zinc-300" },
};

export const DELIVERY_META = {
  prepared: { label: "Prepared for print", tone: "text-zinc-600" },
  provided: { label: "Given to client", tone: "text-emerald-700" },
  sending: { label: "Sending…", tone: "text-zinc-600" },
  sent: { label: "Email sent", tone: "text-emerald-700" },
  failed: { label: "Email failed", tone: "text-red-700" },
  not_sent: { label: "Email not sent", tone: "text-red-700" },
};

export const DECISION_LABEL = {
  submitted: "Sent for review",
  approved: "Approved",
  changes_requested: "Changes requested",
  reviewed_no_change: "Reviewed — no change",
};

let metaPromise = null;
export function loadResourceMeta(force = false) {
  if (!metaPromise || force) metaPromise = api.get("/clinical-resources/meta").then((r) => r.data);
  return metaPromise;
}

export function useResourceMeta() {
  const [meta, setMeta] = useState(null);
  useEffect(() => {
    let live = true;
    loadResourceMeta().then((m) => live && setMeta(m)).catch(() => {});
    return () => { live = false; };
  }, []);
  return meta;
}

export const labelOf = (list, key) => (list || []).find((x) => x.key === key)?.label || key;

export const isPdf = (ct) => (ct || "").includes("pdf");
export const isImage = (ct) => (ct || "").startsWith("image/");
export const isDocx = (ct) => (ct || "").includes("wordprocessingml");

export async function fetchBlob(path, params) {
  const r = await api.get(path, { params, responseType: "blob" });
  return r.data;
}

export function saveBlob(blob, filename) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || "resource";
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export const errText = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
